import { I18n } from "aws-amplify/utils";

export const spanishTranslations = {
  "Sign In": "Iniciar Sesión",
  "Create Account": "Crear Cuenta",
  Email: "Correo Electrónico",
  Password: "Contraseña",
  "Confirm Password": "Confirmar Contraseña",
  "Forgot your password?": "¿Olvidaste tu contraseña?",
  "Sign in": "Iniciar Sesión",
  "Create account": "Crear cuenta",
  "Enter your Email": "Ingresa tu correo electrónico",
  "Enter your Password": "Ingresa tu contraseña",
  "Confirm your Password": "Confirma tu contraseña",
  "Back to Sign In": "Volver a Iniciar Sesión",
  "Reset Password": "Restablecer Contraseña",
  "Send code": "Enviar código",
  "Confirmation Code": "Código de Confirmación",
  "New Password": "Nueva Contraseña",
  Confirm: "Confirmar",
  Submit: "Enviar",
  "Resend Code": "Reenviar Código",
  Skip: "Saltar",
  Verify: "Verificar",
  Code: "Código",
  "Loading...": "Cargando...",
  "Invalid username or password": "Usuario o contraseña inválidos",
  "User does not exist": "El usuario no existe",
  "Incorrect username or password": "Usuario o contraseña incorrectos",
  "Invalid verification code provided, please try again.":
    "Código de verificación inválido, inténtalo de nuevo.",
  Username: "Usuario",
  "Phone Number": "Número de Teléfono",
  "We Sent A Code": "Hemos Enviado Un Código",
  "Lost your code?": "¿Perdiste tu código?",
  "Username/client id combination not found.":
    "Combinación de usuario/ID de cliente no encontrada.",
  "Network error": "Error de red",
  "Something went wrong": "Algo salió mal",
  "Account recovery requires verified contact information":
    "La recuperación de cuenta requiere información de contacto verificada",
  "An account with the given email already exists.":
    "Ya existe una cuenta con el correo electrónico proporcionado.",
  "Username cannot be empty": "El nombre de usuario no puede estar vacío",
  "Password cannot be empty": "La contraseña no puede estar vacía",
  "Password must have at least 8 characters":
    "La contraseña debe tener al menos 8 caracteres",
};

// Configure Spanish translations
I18n.putVocabularies({
  es: spanishTranslations,
});

I18n.setLanguage("es");

/**
 * Traducciones de la aplicacion (brands / marcas)
 * El proyecto usa strings en espanol directamente en los componentes.
 * Esta seccion documenta las claves para futura internacionalizacion.
 */
export const brandsTranslations = {
  "brands.title": "Gestion de Marcas",
  "brands.create": "Crear marca",
  "brands.search": "Buscar marca...",
  "brands.name": "Nombre",
  "brands.suppliers": "Proveedores",
  "brands.products": "Productos",
  "brands.active": "Activa",
  "brands.actions": "Acciones",
  "brands.noResults": "No se encontraron marcas",
  "brands.loading": "Cargando marcas...",
  "brands.createTitle": "Crear nueva marca",
  "brands.brandName": "Nombre de la marca",
  "brands.cancel": "Cancelar",
  "brands.addSupplier": "Agregar proveedor",
  "brands.addSupplierTitle": "Agregar proveedor",
  "brands.supplierName": "Nombre del proveedor",
  "brands.removeSupplier": "Remover proveedor de esta marca",
  "brands.noSuppliers": "Sin proveedores asignados",
  "brands.merge": "Fusionar marcas",
  "brands.mergeTitle": "Fusionar marcas",
  "brands.mergeDescription":
    "Los proveedores y productos de la marca origen se moveran a la marca destino. La marca origen sera eliminada.",
  "brands.mergeSourceId": "ID de la marca origen",
  "brands.mergeSourceHelp": "Ingresa el ID de la marca que deseas absorber",
  "brands.mergeButton": "Fusionar",
  "brands.createdSuccess": "Marca creada correctamente",
  "brands.activatedSuccess": "Marca activada",
  "brands.deactivatedSuccess": "Marca desactivada",
  "brands.supplierAddedSuccess": "Proveedor agregado correctamente",
  "brands.supplierRemovedSuccess": "Proveedor removido",
  "brands.mergedSuccess": "Marcas fusionadas correctamente",
};
